import { TOASTER_TYPES } from './selectors'
import RoutesHelper from 'helpers/RoutesHelper'

import DesktopHelpers from 'helpers/DesktopHelpers'
import { logger } from 'logger'
import history from 'browserHistory'

import {
  CLOSE_ACTIVE_MODAL,
  SET_ACTIVE_ORGANIZATION_ID,
  SET_ACTIVE_USER_ID,
  SET_WARNING_MESSAGE,
  SET_ACTIVE_MODAL,
  CREATE_TOASTER_MESSAGE,
  DISMISS_TOASTER_MESSAGE,
  SET_CONNECTION_STATUS,
  SET_SUBSCRIPTION_STATUS,
  TOGGLE_FOCUS_MODE,
  CREATE_DETACHED_NOTE_WINDOW,
  SET_DETACHED_MODE,
  SET_OUTLINE_CONTAINER_ID,
  RESET_SELECTED_NOTE_IDS,
  COLLAPSE_SIDEBAR,
  UNCOLLAPSE_SIDEBAR,
  TOGGLE_CHANNELS_LIST,
  SET_ROUTE_PARAMS,
  START_DIRECT_EDITING_NOTE,
  STOP_DIRECT_EDITING_NOTE,
} from './actionTypes'
import { trackNavigateToUpgrade } from 'data/analytics/actions'

export const collapseSidebar = () => ({
  type: COLLAPSE_SIDEBAR,
  meta: {
    analytics: {
      type: 'COLLAPSE_SIDEBAR',
    },
  },
})

export const uncollapseSidebar = () => ({
  type: UNCOLLAPSE_SIDEBAR,
})

export const setActiveOrganizationId = id => ({
  type: SET_ACTIVE_ORGANIZATION_ID,
  payload: { id },
})

export const setActiveUserId = id => ({
  type: SET_ACTIVE_USER_ID,
  payload: { id },
})

export const setActiveModal = ({
  id,
  meta = undefined,
  analytics = undefined,
}) => ({
  type: SET_ACTIVE_MODAL,
  payload: { id, meta },
  meta: { analytics },
})

export const closeActiveModal = () => ({
  type: CLOSE_ACTIVE_MODAL,
  payload: null,
})

export const setWarningMessage = warningMessage => ({
  type: SET_WARNING_MESSAGE,
  payload: { warningMessage },
})

export const createToasterMessage = ({
  title,
  detail,
  id,
  type = TOASTER_TYPES.SUCCESS,
  renderAction = null,
}) => ({
  type: CREATE_TOASTER_MESSAGE,
  payload: { title, detail, id, type, renderAction },
})

export const createSuccessToasterMessage = ({
  title,
  detail,
  id,
  renderAction = null,
}) =>
  createToasterMessage({
    title,
    detail,
    id,
    renderAction,
    type: TOASTER_TYPES.SUCCESS,
  })

export const createWarningToasterMessage = ({
  title,
  detail,
  id,
  renderAction = null,
}) =>
  createToasterMessage({
    title,
    detail,
    id,
    renderAction,
    type: TOASTER_TYPES.WARNING,
  })

export const createInfoToasterMessage = ({
  title,
  detail,
  id,
  renderAction = null,
}) =>
  createToasterMessage({
    title,
    detail,
    id,
    renderAction,
    type: TOASTER_TYPES.INFO,
  })

export const createErrorToasterMessage = ({
  title,
  detail,
  id = undefined,
  renderAction = null,
}) =>
  createToasterMessage({
    title,
    detail,
    id,
    renderAction,
    type: TOASTER_TYPES.ERROR,
  })

export const createConnectionWarningToasterMessage = () =>
  createWarningToasterMessage({
    title: 'The connection to Slite seems unstable.',
    detail: 'Your data may be desynchronized.',
    id: 'unstable-connectivity',
  })

export const dismissToasterMessage = ({ id }) => ({
  type: DISMISS_TOASTER_MESSAGE,
  payload: { id },
})

export const setConnectionStatus = ({ status, service }) => {
  logger.debug('Connection status', service, status)

  return {
    type: SET_CONNECTION_STATUS,
    payload: { status, service },
  }
}

export const setSubscriptionStatus = ({ type, data }) => {
  logger.debug('Subscription status', type)

  return {
    type: SET_SUBSCRIPTION_STATUS,
    payload: { type, data },
  }
}

export const startDirectEditingNote = () => ({
  type: START_DIRECT_EDITING_NOTE,
})

export const stopDirectEditingNote = () => ({
  type: STOP_DIRECT_EDITING_NOTE,
})

export const toggleFocusMode = () => {
  return {
    type: TOGGLE_FOCUS_MODE,
    meta: {
      analytics: {
        type: 'OPEN_FOCUS_MODE',
      },
    },
  }
}

export const toggleChannelsList = () => {
  return {
    type: TOGGLE_CHANNELS_LIST,
    meta: {
      analytics: {
        type: TOGGLE_CHANNELS_LIST,
      },
    },
  }
}

export const enableDetachedMode = ({ noteId }) => {
  const url = RoutesHelper.noteDetached({ noteId })
  if (DesktopHelpers.isAppDesktop()) {
    window.electron.ipcRenderer.send(
      'app.openWindow',
      `${window.location.origin}${url}`
    )
  } else {
    // setTimeout prevents chromes from forcing to open in a new tab when pressing cmd + click (event if we preventDefault)
    setTimeout(
      // Frame name ensure one external window per note
      () => window.open(url, `detached-note-${noteId}`, 'width=800,height=600'),
      0
    )
  }

  return {
    type: CREATE_DETACHED_NOTE_WINDOW,
    payload: { noteId },
  }
}

export const setDetachedMode = () => {
  return {
    type: SET_DETACHED_MODE,
    meta: {
      analytics: {
        type: 'OPEN_DETACHED_MODE',
      },
    },
  }
}

export const setOutlineContainerId = containerId => {
  const meta = containerId
    ? {
        analytics: {
          type: 'OPEN_OUTLINE',
        },
      }
    : {}
  return {
    type: SET_OUTLINE_CONTAINER_ID,
    payload: {
      containerId,
    },
    meta,
  }
}

export const resetSelectedNoteIds = () => {
  return {
    type: RESET_SELECTED_NOTE_IDS,
    payload: {},
  }
}

export const setRouteParams = payload => {
  return {
    type: SET_ROUTE_PARAMS,
    payload,
  }
}

export const goToOrganizationUpgrade = ({ incentiveId = null } = {}) => ({
  dispatch,
}) => {
  // Ensure no modal is currently open
  dispatch(closeActiveModal())
  // Redirect to billing page
  history.push(RoutesHelper.settingsOrganizationBillingUpgrade())
  // Send tracking to follow which incentive has been clicked
  return dispatch(trackNavigateToUpgrade({ incentiveId }))
}
